import commonType from "./actionTypes"



// function that called as action
const getIgarashiInfo = action => ({
  type: commonType.GET_INFO_IGARASHI,
  action
})

const getIgarashiInfoSuccess = data => ({
  type: commonType.GET_INFO_IGARASHI_SUCCESS,
  payload: data,
})



const CommonAction = {
  getIgarashiInfo,
  getIgarashiInfoSuccess
}

export default CommonAction





